import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ModalDeleteItem from '../../Modal-Delete-Item';
import EctoStatus from './Ecto-Status';
import { Kanban } from 'libs/kanban';
import { TabPaneStyles } from '../Tab-Pane-Focuses/styles';

const TabPaneEctoStatus = ({ setStatus, ectoStatus, setEctoStatus }) => {
  const { t: translate } = useTranslation();
  const { search } = window.location;
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const seo = new Kanban('seo', accountParam);
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const toggleModal = () => {
    const willClose = isOpenModalDelete;
    setIsOpenModalDelete(!isOpenModalDelete);

    if (willClose) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const deleteStatus = async () => {
    return seo.deleteTypeItem('ecto-status', selectedStatus.id);
  };

  return (
    <TabPaneStyles>
      <span>Status Ecto</span>
      <div className="d-flex flex-column gap-2">
        {(Array.isArray(ectoStatus) ? ectoStatus.filter(Boolean) : []).map((status) => (
          <EctoStatus
            key={status?.id}
            id={status?.id}
            name={status?.name}
            setItems={setEctoStatus}
            index={ectoStatus.filter(Boolean).findIndex((col) => col.id === status.id)}
            total={ectoStatus.filter(Boolean).length}
            isNew={status.isNew}
            setSelectedItem={setSelectedStatus}
            setIsOpenModalDelete={setIsOpenModalDelete}
            setStatus={setStatus}
          />
        ))}
        <Button
          color="outline"
          style={{ width: '37.5rem' }}
          onClick={() => {
            if (!Array.isArray(ectoStatus)) {
              setEctoStatus([{ id: 'temp-1', name: '', isNew: true }]);
            } else {
              setEctoStatus([
                ...ectoStatus.filter(Boolean),
                { id: `temp-${ectoStatus.filter(Boolean).length + 1}`, name: '', isNew: true },
              ]);
            }
          }}
        >
          <i className="bx bx-plus" />
          {translate('Add status')}
        </Button>
      </div>
      <ModalDeleteItem
        isOpen={isOpenModalDelete}
        toggle={toggleModal}
        item={selectedStatus}
        setItems={setEctoStatus}
        setStatus={setStatus}
        onDelete={deleteStatus}
        headerText="Delete status"
        bodyText="Are you sure you want to delete the status {{item}}?"
      />
    </TabPaneStyles>
  );
};

TabPaneEctoStatus.propTypes = {
  setStatus: PropTypes.func.isRequired,
  ectoStatus: PropTypes.array.isRequired,
  setEctoStatus: PropTypes.func.isRequired,
};

export default TabPaneEctoStatus;
